import { jsx as _jsx } from "react/jsx-runtime";
import SearcherSkeleton from "../../../searcher/skeleton/index.js";
import { SearcherItemAge as SearcherCarItemAge, SearcherItemDate as SearcherCarItemDate, SearcherItemOrigin as SearcherCarItemOrigin } from "../../views/desktop/styled.js";
const SearcherCarSkeleton = ({ onModal  })=>/*#__PURE__*/ _jsx(SearcherSkeleton, {
        config: {
            desktop: {
                variants: [
                    {
                        variant: 'large',
                        grow: true,
                        Component: SearcherCarItemOrigin
                    },
                    {
                        variant: 'larger',
                        Component: SearcherCarItemDate
                    },
                    {
                        variant: 'larger',
                        Component: SearcherCarItemDate
                    },
                    {
                        variant: 'small',
                        Component: SearcherCarItemAge
                    }
                ]
            },
            mobile: {
                variants: 5
            }
        },
        onModal: onModal
    });
export default SearcherCarSkeleton;

//# sourceMappingURL=index.js.map